<template>
  <div class="address-box">
    <div class="address-box-list">
      <div class="address-list-box" v-for="(item2, index) in detail.pointList" :key="index">
        <div class="address-list-box-top">
          <div class="label" :class="item2.loadType === 1 ? 'zhuang' : 'xie'">
            {{ item2.loadType === 1 ? "装" : "卸" }}
          </div>
          <div class="name">{{ item2.cityName }}{{ item2.districtName }}</div>
        </div>
        <div class="detail-address">{{item2.address}}</div>
      </div>
    </div>
    <div class="address-box-date-price">
      <div class="dress-date">装货时间：<span class="dress-date-num">{{detail.startLoadTime}}:00</span></div>
      <div class="dress-date" v-if="detail.orderFrom === 21">第三方订单号：<span class="dress-date-num">{{detail.sourceOrderNo || "-"}}</span></div>

      <div class="price-box" v-if="showCancelOperate">
        <template v-if="showCancelBtn">
          <el-button type="primary" @click="handleCancelOrder" :loading="loading">取消订单</el-button>
        </template>
<!--        <div class="price-box-money">-->
<!--          <span class="money-num">{{ detail.payableFee || "-" }}</span>-->
<!--          <span class="money-unit">元/趟</span>-->
<!--        </div>-->
<!--        <div class="price-box-ding" v-if="detail.orderSource && detail.orderSource === 2">-->
<!--          <span class="ding-txt">订金</span>-->
<!--          ：<span class="ding-price">{{detail.deposit || "-" }}元</span>-->
<!--          ({{detail.canRefund?'可退':'不可退'}})-->
<!--        </div>-->
      </div>
    </div>
    <addPrice ref="addPriceRef" @success="cancelSuccess"></addPrice>
  </div>
</template>
<script>
import addPrice from "@/components/customComponents/addPrice.vue";
import { cancelOrder } from "@/views/OrderManagement/api";
export default {
  name: "AddressTemplate",
  components: {
    addPrice
  },
  props: {
    detail: {
      type: Object,
      default: () =>{
        return {}
      }
    },
    showCancelOperate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showCancelBtn: function () {
      let b = false
      // 之前逻辑取消， 现在改成只要不是已完成和已取消，都给他展示出来，反正他们现在是后台审核 不是-1和100，都可以取消
      // if (this.detail.orderSource === 2) {
      //   b = false
      // } else {
      //
      //   if (this.detail.orderStatus === 0) {
      //     // 取消状态
      //     b = false
      //   } else if (this.detail.orderStatus === 1 || this.detail.orderStatus === 10) {
      //     // 1待支付，10待派单
      //     b = true
      //   } else if (this.detail.orderStatus === 20) {
      //     // 进行中
      //
      //     if (this.driverToZhd()) {
      //       // 如果起点装货没装 还可以取消
      //       b = true
      //     }
      //   } else {
      //     b = false
      //   }
      // }
      // return b
      if (this.detail.orderStatus === 0 || this.detail.orderStatus === 100) {
        b = false
      } else {
        b = true
      }
      return b
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    cancelSuccess() {
      this.$emit('cancelSuccess', this.detail.orderId)
    },
    handleCancelOrder() {
      // 如果需要退款，则先输入金额
      if (this.detail.needRefund) {
        this.$refs.addPriceRef.init(this.detail)
      } else {
        this.cancelOrder()
      }
    },
    cancelOrder() {
      this.$confirm(`确定取消当前订单？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.loading = true
        cancelOrder({ orderId: this.detail.orderId, refundAmount: 0, }).then((res) => {
          if (res.code === 200) {
            this.$message.success("订单取消成功");
            this.cancelSuccess()
          }
        }).finally(() => {
          this.loading = false
        });
      });
    },
    driverToZhd() {
      let status = false
      let arr = [...this.detail.pointList]
      if (arr && arr.length > 0) {
        if (arr[0].completeStatus === 0) {
          status = true
        }
      }
      return status
    },
  }
}
</script>

<style scoped lang="scss">
.address-box {
  width: 100%;
  .address-box-list {
    display: flex;
    position: relative;
    .address-list-box {
      padding-right: 0.35rem;
      position: relative;
      .address-list-box-top {
        display: flex;
        align-items: center;
        .label {
          flex-shrink: 0;
          width: 0.2rem;
          height: 0.2rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 0.02rem;
          font-size: 0.12rem;
        }
        .zhuang {
          color: #5cc41a;
          background-color: rgba(92, 196, 26, 0.3);
        }
        .xie {
          color: #e52019;
          background-color: rgba(229, 32, 25, 0.3);
        }
        .name {
          color: #000000;
          font-size: 0.16rem;
          line-height: 0.2rem;
          padding-left: 0.04rem;
        }
      }
      .detail-address{
        line-height: 1.5;
        padding-top: 0.03rem;
      }
    }
    .address-list-box::before {
      content: "→";
      font-size: 0.2rem;
      position: absolute;
      right: 0.15rem;
      top: 0rem;
      color: #52c41a;
    }
    .address-list-box:nth-last-of-type(1)::before {
      display: none;
    }
  }
  .address-box-date-price{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 0.06rem;
    .dress-date{
      font-size: 0.14rem;
      .dress-date-num{
        font-size: 0.16rem;
        color: #0a65f0;
      }
    }
    .price-box {
      display: flex;
      align-items: center;
      .price-box-money {
        display: flex;
        justify-content: right;
        align-items: baseline;
        color: #faad14;
        .money-num {
          font-size: 0.18rem;
          padding-bottom: 0.06rem;
        }
        .money-unit {
          font-size: 0.12rem;
          padding-left: 0.04rem;
        }
      }
      .price-box-ding {
        padding-left: 0.1rem;
        font-size: 0.14rem;
        .ding-txt {
          color: #000000;
        }
        .ding-price{
          color: #0a65f0;
          font-size: 0.16rem;
        }
      }
    }
  }

}
</style>
